import React from 'react';

import BEM from '@scripts/utilities/bem.js';


class ResponsiveEmbed extends React.Component {
  render() {
    if (this.props.embed) {
      var innerHtml = {
        __html: this.props.embed
      };

      return (
        <div
          className={BEM.classString('sbm-responsive-embed', this.props.variant)}
          dangerouslySetInnerHTML={innerHtml}
        />
      );
    } else {
      return <div className={BEM.classString('sbm-responsive-embed', this.props.variant)} />;
    }
  }
}

export default ResponsiveEmbed;

